module.exports = __webpack_public_path__ + "img/slide-3.857ad542.jpg";